import * as angular from "angular";
import {ApiUrl} from "../models/app-config.model";

export class CookieMonsterService {
  /* @ngInject */
  constructor(
    private API_URL: ApiUrl,
    private $http: angular.IHttpService
  ) {
  }

  getAll(cache: boolean = true) {
    return this.$http.get(`${this.API_URL.cookieMonster}`, {cache: cache})
      .then(response => {
        return response.data;
      });
  }

  get(key, cache: boolean = true) {
    return this.$http.get(`${this.API_URL.cookieMonster}/${key}`, {cache: cache})
      .then(response => {
        return response.data;
      })
      .catch(() => null);
  }

  set(key, value) {
    return this.$http.post(`${this.API_URL.cookieMonster}`, {
        key: key,
        value: value
      })
      .then(response => {
        return response.data;
      });
  }

  delete(key) {
    return this.$http.delete(`${this.API_URL.cookieMonster}/${key}`)
      .then(response => {
        return response.data;
      });
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/cookie-monster/cookie-monster.service.ts
 **/